import styled from 'styled-components';

// Import types
import { ImageType, ChannelImages } from 'types/api/images';

// Import helpers
import { getImage } from 'helpers/images';

// Import styles
export const Image = styled.img<{ ratio?: string }>`
	width: 100%;
	object-fit: contain;
	object-position: center;
	pointer-events: none;
	aspect-ratio: ${({ ratio = '1/1' }) => ratio};
`;

type Props = {
	title: string;
	images: ChannelImages;
	ratio?: string;
};

export const ChannelImage = ({ title, images, ratio }: Props) => {
	const image = getImage(images, [ImageType.Logo]);

	return <Image src={image} alt={title} ratio={ratio} />;
};
